import { render, staticRenderFns } from "./planned-issue-definition.vue?vue&type=template&id=ab3ecf1c&"
import script from "./planned-issue-definition.vue?vue&type=script&lang=js&"
export * from "./planned-issue-definition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports